import { pickupActionTypes } from '../actions/pickupActions.js';

const initState = {
  restaurants: [],
  restaurantsLoaded: false,
  restaurantsLoadFailed: false,
};

const handleGetRestuarantSuccess = (state, action) => {
  return {
    ...state,
    ...{
      restaurants: action.restaurants,
      restaurantsLoaded: true,
      restaurantsLoadFailed: false,
    },
  };
};

const PickupReducer = (state = initState, action) => {
  switch (action.type) {
    case pickupActionTypes.getRestaurantsStart:
      return {
        ...state,
        ...{
          restaurantsLoaded: false,
          restaurantsLoadFailed: false,
        },
      };
    case pickupActionTypes.getRestaurantsSuccess:
      return handleGetRestuarantSuccess(state, action);
    case pickupActionTypes.getRestaurantsFailed:
      return {
        ...state,
        ...{
          restaurantsLoaded: false,
          restaurantsLoadFailed: true,
        },
      };
    default:
      return state;
  }
};

export default PickupReducer;
